import React from 'react';
import { Form, FormInstance, Input, DatePicker, UploadFile } from 'antd';
import { UploadDragger } from '@common/components';
import moment from 'moment';

type Props = {
  form: FormInstance;
  onFormSubmit: (value: Record<string, string>) => void;
};

export function SuppliersManagementCreateFileForm({
  form,
  onFormSubmit,
}: Props) {
  const draggerProps = {
    name: 'file',
    action: '',
    text: 'Drag files to upload',
    beforeUpload() {
      return false; // Prevent defined 'action' from being triggered
    },
    onChange({ file }: { file: UploadFile }) {
      if (!form.getFieldValue('fileName')) {
        const fileName = file.name.split('.')[0]; // File name without extension
        form.setFieldValue('fileName', fileName);
      }
    },
  };

  return (
    <Form layout="vertical" form={form} onFinish={onFormSubmit}>
      <Form.Item
        label="Name"
        name="fileName"
        rules={[{ required: true, message: 'Please type a file name' }]}
      >
        <Input size="large" placeholder="Type a file name" />
      </Form.Item>

      <Form.Item label="Expiration Date" name="expiresOn">
        <DatePicker
          placeholder="Select a date"
          format="MM/DD/YYYY"
          size="large"
          style={{ width: '50%' }}
          disabledDate={(current) => current < moment().endOf('day')}
        />
      </Form.Item>

      <Form.Item
        label="Upload"
        name="file"
        key="file"
        valuePropName="file"
        rules={[{ required: true, message: 'Please choose a file' }]}
      >
        <UploadDragger {...draggerProps} />
      </Form.Item>
    </Form>
  );
}
